/* Casa de Diciembre · Kit regalo del Pack Regalo de los calendarios de charms.
   Usa el sistema de regalos de cdd-gift-sync.js (se carga antes): registra el kit como regalo de cada
   variante «Pack Regalo», así se añade al carrito como línea propia (_gift_for) y se sincroniza solo.
   Además copia las propiedades visibles del formulario (Inicial) a las líneas items[] que monta gift-sync. */
(function () {
  if (window.__cddKitRegalo) return;
  window.__cddKitRegalo = true;
  var G = window.CDDGifts;
  if (!G || !G.map) return;

  var KIT = 58050740781396; // Kit regalo: bolsa, tarjeta e inicial (0 €, oculto)
  var PACKS = ['58040014504276', '58040037867860', '58040038490452']; // Pack Regalo Stitch · Mickey · Winnie
  PACKS.forEach(function (v) { G.map[v] = [[KIT, 1]]; });

  // Va después del listener de gift-sync (mismo document, fase de captura, registrado más tarde).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var box = form.querySelector('[data-cdd-gift-inputs]');
    if (!box) return;
    var idx = [], isPack = false;
    box.querySelectorAll('input').forEach(function (i) {
      var m = /^items\[(\d+)\]\[id\]$/.exec(i.name || '');
      if (!m) return;
      idx.push(m[1]);
      if (PACKS.indexOf(String(i.value)) !== -1) isPack = true;
    });
    if (!isPack) return;
    form.querySelectorAll('input[name^="properties["]').forEach(function (p) {
      var k = /^properties\[(.+)\]$/.exec(p.name);
      if (!k || !p.value) return;
      idx.forEach(function (n) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'items[' + n + '][properties][' + k[1] + ']';
        h.value = p.value;
        box.appendChild(h);
      });
    });
  }, true);
})();
